<template>
  <div>
    <v-layout row>
      <v-flex xs12 md6 lg4 v-for="(membership, i) in projects" :key="i" class="mt-5">
        <v-card class="mx-auto mb-3 mr-3 ml-3" flat outlined rounded @click="selectProjectAndGo(membership)">
          <v-card-title class="text-subtitle-1">
            Project: {{ membership.project.name }}
            <v-spacer></v-spacer>

            <v-menu class="items" top left transition="v-slide-y-transition">
              <template v-slot:activator="{ on: on }">
                <v-btn small icon v-on="on" :class="$store.state.theme === 'light'
          ? 'secondary--text'
          : ''
        ">
                  <v-icon small>more_vert</v-icon>
                </v-btn>
              </template>

              <v-list dense>
                <v-list-item :to="{
        name: 'projectDetails',
        params: {
          project: membership.project.id,
        },
      }" router>
                  <v-list-item-title>Details</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-card-title>
          <v-card-text>
            <span class="text-caption">Devices: {{ membership.project.deviceCount }} | Applications: {{
        membership.project.applicationCount }} | Members: {{ membership.project.membersCount }}</span>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </div>

</template>

<script>

export default {
  components: {
  },

  data() {
    return {
      selectedProject: null,
    }
  },

  props: {
    projects: {
      type: Array,
      required: true,
    },
  },

  methods: {
    selectProjectAndGo(selectedProject) {
      this.$store.dispatch('SelectProject', selectedProject.projectId)
      this.$store.dispatch('ResetDevicesList').then(() => {
        this.$router.push({
          name: 'devices',
          params: {
            project: selectedProject.projectId,
          },
        })
      })
    },
  }
}
</script>